export default "__VITE_ASSET__CnpyZ4Fl__"